import { InputText } from "primereact/inputtext";
import * as React from "react";

const PrwcGlobalFilter = (props: any) => {
  return (
    <>
      <InputText
        className={props.className}
        value={props.value || ""}
        onChange={(e: any) => props.onChange(e.target.value)}
      />
    </>
  );
};

export default PrwcGlobalFilter;
